import AcceptanceReport from './AcceptanceReport'
import ActivitiesReport from './ActivitiesReport'
import AcceptanceReportPdf from './components/AcceptanceReportPdf'
import AssetInventory from './AssetInventoryReport'
import IncidentsReports from './IncidentsReports'
import MainAccountability from './Accountability'
import MainAuditReport from './AuditReport'
import MainConsent from './ConsentReport'
import MainControlReport from './ControlReport'
import MainCookiesConsentsReport from './CookiesConsentsReport'
import MainCookiesTagsReport from './CookiesTagsReport'
import MainFragilityReport from './FragilityReport'
import MainLia from './LiaReport'
import MainManagement from './Management'
import MainPartnersReport from './PartnersReport'
import MainPhishingReport from './PhishingReport'
import MainPrivacyByDesignReport from './PrivacyByDesignReport'
import MainRipd from './ImpactReport'
import MainRmcReport from './ReportRmc'
import MainRopa from './RopaReport'
import TrainingReport from './TrainingReport'
import ValidateReport from './ValidateReport'

export default {
  AcceptanceReport,
  ActivitiesReport,
  AcceptanceReportPdf,
  AssetInventory,
  IncidentsReports,
  MainAccountability,
  MainAuditReport,
  MainConsent,
  MainControlReport,
  MainCookiesConsentsReport,
  MainCookiesTagsReport,
  MainFragilityReport,
  MainLia,
  MainManagement,
  MainPartnersReport,
  MainPhishingReport,
  MainPrivacyByDesignReport,
  MainRipd,
  MainRmcReport,
  MainRopa,
  TrainingReport,
  ValidateReport,
}
